"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _core = require("@material-ui/core/");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _LogoJMM = _interopRequireDefault(require("@jobmatchme/ui/es/components/LogoJMM"));

var _Modal = _interopRequireDefault(require("@jobmatchme/ui/es/components/Modal"));

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _Headline = _interopRequireDefault(require("../Headline"));

var _VerticalSelection = _interopRequireDefault(require("../VerticalSelection"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var translateNs = 'pc-matching:Verticals';

var Verticals = function Verticals(_ref) {
  var verticals = _ref.verticals,
      setVertical = _ref.setVertical;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return typeof verticals === 'undefined' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {
    fullPage: true
  }) : verticals.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
    delay: 700,
    transition: 0.5,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
      opacity: 0.4,
      open: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Card, {
        elevation: 3,
        className: _styleModule.default.content,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_core.CardContent, {
          className: _styleModule.default.cardContent,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
            textAlign: "center",
            mb: 6,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoJMM.default, {
              globalThemeVariant: "jmm",
              size: "small",
              height: "30"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
            textAlign: "center",
            mb: 8,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
              variant: "h4",
              component: "h1",
              color: "jmmdark",
              className: _styleModule.default.welcomeText,
              text: t("".concat(translateNs, ".modal.title"))
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Grid, {
            spacing: 6,
            container: true,
            className: _styleModule.default.modalBtnGrid,
            children: verticals.map(function (d) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Grid, {
                item: true,
                xs: 12,
                sm: 6,
                md: 6,
                lg: 6,
                xl: 6,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
                  className: _styleModule.default.modalBtn,
                  variant: "contained",
                  color: "default",
                  round: true,
                  flat: true,
                  extraBold: true,
                  texttransform: "none",
                  onClick: function onClick() {
                    return setVertical(d);
                  },
                  fullWidth: true,
                  children: t("".concat(translateNs, ".modal.").concat(d))
                })
              }, d);
            })
          })]
        })
      })
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalSelection.default, {});
};

var _default = Verticals;
exports.default = _default;